// утилиты, связанные с метаданными

import {IMetaActionInfo} from 'entities/metadata';

interface IAreRequiredQueryParamsPresentProps {
    requiredQueryParams: IMetaActionInfo['requiredQueryParams'];
    getQueryParam: (name: string) => (string | null);
}
export const areRequiredQueryParamsPresent = ({
    requiredQueryParams,
    getQueryParam,
}: IAreRequiredQueryParamsPresentProps): boolean => (
    !requiredQueryParams?.some((rp: string) => !getQueryParam(rp))
);
